export const PracticeFrontAccessPoint = process.env.REACT_APP_PRACTICE_FRONT_ACCESS_POINT || '';
export const PracticeFrontAccessPointStage = process.env.REACT_APP_PRACTICE_FRONT_ACCESS_POINT_STAGE || '';